import React from 'react';
import { VideoPlayer } from './ui';
export const Hero = () => {
  return <section className="bg-brand-cream py-10 md:py-16 px-4 text-center" data-id="element-93">
      <div className="max-w-4xl mx-auto" data-id="element-94">
        <p className="font-sans font-bold uppercase text-gray-500 mx-auto mb-7 max-w-[320px]" style={{
        fontSize: '12px',
        letterSpacing: '0.18em',
        lineHeight: 1.4
      }} data-id="element-95">
          <span className="hidden md:inline" style={{
          fontSize: '13px'
        }} data-id="element-96">
            PARA AMANTES DE LA REPOSTERÍA Y PANADERÍA SALUDABLE
          </span>
          <span className="md:hidden" data-id="element-97">
            PARA AMANTES DE LA REPOSTERÍA Y PANADERÍA SALUDABLE
          </span>
        </p>

        <h1 className="font-serif text-brand-dark mx-auto" style={{
        fontSize: 'clamp(38px, 7vw, 64px)',
        lineHeight: 1.08,
        letterSpacing: '-0.02em',
        fontWeight: 600,
        maxWidth: '850px'
      }} data-id="element-98">
          El error invisible que arruina el{' '}
          <span className="font-serif" style={{
          color: '#e33434',
          textDecoration: 'underline',
          textDecorationColor: '#e33434',
          textDecorationThickness: '2px',
          textUnderlineOffset: '6px',
          fontWeight: 600
        }} data-id="element-99">
            93% de los pasteles
          </span>{' '}
          sin gluten
        </h1>

        <p className="font-serif italic mx-auto" style={{
        color: '#ef4444',
        fontWeight: 400,
        fontSize: 'clamp(22px, 3.2vw, 30px)',
        lineHeight: 1.3,
        marginTop: '14px',
        marginBottom: '36px'
      }} data-id="element-100">
          (y no tiene nada que ver con la harina)
        </p>

        <div style={{
        marginTop: '28px'
      }} className="mb-12" data-id="element-101">
          <VideoPlayer src="https://i.imgur.com/QA7O5XO.mp4" data-id="element-102" />
        </div>

        <div className="mx-auto space-y-5 text-center" style={{
        maxWidth: '720px'
      }} data-id="element-103">
          <p className="font-sans" style={{
          fontSize: 'clamp(19px, 2.2vw, 21px)',
          lineHeight: 1.55,
          color: '#374151'
        }} data-id="element-104">
            Si alguna vez horneaste un pastel sin gluten, sin lácteos o sin
            azúcar y terminó seco, quebradizo o con sabor extraño…
          </p>

          <p className="font-sans font-bold text-brand-red" style={{
          fontSize: 'clamp(20px, 2.4vw, 24px)',
          lineHeight: 1.4
        }} data-id="element-105">
            👉 No es tu culpa.
          </p>

          <p className="font-sans" style={{
          fontSize: 'clamp(19px, 2.2vw, 21px)',
          lineHeight: 1.55,
          color: '#374151'
        }} data-id="element-106">
            El problema no está en los ingredientes.
          </p>

          <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-6 shadow-sm my-6" data-id="element-107">
            <p className="font-sans font-medium text-yellow-900" style={{
            fontSize: 'clamp(18px, 2.1vw, 20px)',
            lineHeight: 1.5
          }} data-id="element-108">
              Está en cómo se construye la humedad del pastel antes de entrar al
              horno.
            </p>
          </div>

          <p className="font-sans font-medium" style={{
          fontSize: 'clamp(19px, 2.2vw, 21px)',
          lineHeight: 1.55,
          color: '#374151'
        }} data-id="element-109">
            Y eso casi nadie te lo explica.
          </p>
        </div>
      </div>
    </section>;
};